import { TOActions } from "./Action";

let initialState = {
  TOOrderData: null,
  TOOrderErr: null,
  TOBoxLogsData: null,
  TOBoxLogsErr: null,
  TOPickerUpdateMedData: null,
  TOPickerUpdateMedErr: null,
  TOMedBatchesData: null,
  TOMedBatchesErr: null,
  TOCheckerOrderData: null,
  TOCheckerOrderErr: null,
  TOCheckerBoxesData: null,
  TOCheckerBoxesErr: null,
  TOCheckerIssueMedData: null,
  TOCheckerIssueMedErr: null,
  UpdateRackData: null,
  UpdateRackErr: null,
  GetRackData: null,
  GetRackErr: null,
  GetRackLocationData: null,
  GetRackLocationErr: null,
  UpdateRackLocationData: null,
  UpdateRackLocationErr: null,
  ElasticData: null,
  ElasticErr: null,
  BinData: null,
  BinErr: null,
  TaskIdData: null,
  TaskIdErr: null,
  PickDoneData: null,
  PickDoneErr: null,
  TaskIdDetailsData: null,
  TaskIdDetailsErr: null,
  GetBinData: null,
  GetBinErr: null,
  BinPickData: null,
  BinPickErr: null,
};

export const TOReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOActions.FETCH_TO_PICKER_SUCCESS:
      return {
        ...initialState,
        TOOrderData: action.payload,
        TOOrderErr: null,
      };

    case TOActions.FETCH_TO_PICKER_FAILURE:
      return {
        ...initialState,
        TOOrderData: null,
        TOOrderErr: action.payload,
      };

    case TOActions.FETCH_TO_BOX_LOGS_SUCCESS:
      return {
        ...initialState,
        TOBoxLogsData: action.payload,
        TOBoxLogsErr: null,
      };

    case TOActions.FETCH_TO_BOX_LOGS_FAILURE:
      return {
        ...initialState,
        TOBoxLogsData: null,
        TOBoxLogsErr: action.payload,
      };

    case TOActions.UPDATE_TO_MED_SUCCESS:
      return {
        ...initialState,
        TOPickerUpdateMedData: action.payload,
        TOPickerUpdateMedErr: null,
      };

    case TOActions.UPDATE_TO_MED_FAILURE:
      return {
        ...initialState,
        TOPickerUpdateMedData: null,
        TOPickerUpdateMedErr: action.payload,
      };

    case TOActions.FETCH_TO_BATCHES_SUCCESS:
      return {
        ...initialState,
        TOMedBatchesData: action.payload,
        TOMedBatchesErr: null,
      };

    case TOActions.FETCH_TO_BATCHES_FAILURE:
      return {
        ...initialState,
        TOMedBatchesData: null,
        TOMedBatchesErr: action.payload,
      };

    case TOActions.FETCH_CHECKER_TOID_SUCCESS:
      return {
        ...initialState,
        TOCheckerOrderData: action.payload,
        TOCheckerOrderErr: null,
      };

    case TOActions.FETCH_CHECKER_TOID_FAILURE:
      return {
        ...initialState,
        TOCheckerOrderData: null,
        TOCheckerOrderErr: action.payload,
      };

    case TOActions.GET_TO_BOXES_SUCCESS:
      return {
        ...initialState,
        TOCheckerBoxesData: action.payload,
        TOCheckerBoxesErr: null,
      };

    case TOActions.GET_TO_BOXES_FAILURE:
      return {
        ...initialState,
        TOCheckerBoxesData: null,
        TOCheckerBoxesErr: action.payload,
      };

    case TOActions.MARK_MEDISSUE_SUCCESS:
      return {
        ...initialState,
        TOCheckerIssueMedData: action.payload,
        TOCheckerIssueMedErr: null,
      };

    case TOActions.MARK_MEDISSUE_FAILURE:
      return {
        ...initialState,
        TOCheckerIssueMedData: null,
        TOCheckerIssueMedErr: action.payload,
      };

    case TOActions.UPDATE_RACK_SUCCESS:
      return {
        ...initialState,
        UpdateRackData: action.payload,
        UpdateRackErr: null,
      };

    case TOActions.UPDATE_RACK_FAILURE:
      return {
        ...initialState,
        UpdateRackData: null,
        UpdateRackErr: action.payload,
      };

    case TOActions.GET_RACK_SUCCESS:
      return {
        ...initialState,
        GetRackData: action.payload,
        GetRackErr: null,
      };

    case TOActions.GET_RACK_FAILURE:
      return {
        ...initialState,
        GetRackData: null,
        GetRackErr: action.payload,
      };

    case TOActions.ELASTIC_DATA_SUCCESS:
      return {
        ...initialState,
        ElasticData: action.payload,
        ElasticErr: null,
      };

    case TOActions.ELASTIC_DATA_FAILURE:
      return {
        ...initialState,
        ElasticData: null,
        ElasticErr: action.payload,
      };

    case TOActions.GET_RACK_LOCATION_SUCCESS:
      return {
        ...initialState,
        GetRackLocationData: action.payload,
        GetRackLocationErr: null,
      };

    case TOActions.GET_RACK_LOCATION_FAILURE:
      return {
        ...initialState,
        GetRackLocationData: null,
        GetRackLocationErr: action.payload,
      };

    case TOActions.UPDATE_RACK_LOCATION_SUCCESS:
      return {
        ...initialState,
        UpdateRackLocationData: action.payload,
        UpdateRackLocationErr: null,
      };

    case TOActions.UPDATE_RACK_LOCATION_FAILURE:
      return {
        ...initialState,
        UpdateRackLocationData: null,
        UpdateRackLocationErr: action.payload,
      };

    case TOActions.FETCH_BIN_SUCCESS:
      return {
        ...initialState,
        BinData: action.payload,
        BinErr: null,
      };

    case TOActions.FETCH_BIN_FAILURE:
      return {
        ...initialState,
        BinData: null,
        BinErr: action.payload,
      };

    case TOActions.FETCH_TASKID_SUCCESS:
      return {
        ...initialState,
        TaskIdData: action.payload,
        TaskIdErr: null,
      };

    case TOActions.FETCH_TASKID_FAILURE:
      return {
        ...initialState,
        TaskIdData: null,
        TaskIdErr: action.payload,
      };
    case TOActions.PRODUCTS_YET_TO_FETCH_SUCCESS:
      return {
        ...initialState,
        TaskIdData: action.payload,
        TaskIdErr: null,
      };

    case TOActions.PRODUCTS_YET_TO_FETCH_FAILURE:
      return {
        ...initialState,
        ProductToRackData: null,
        ProductToRackErr: action.payload,
      };

    case TOActions.PICKING_DONE_SUCCESS:
      return {
        ...initialState,
        PickDoneData: action.payload,
        PickDoneErr: null,
      };

    case TOActions.PICKING_DONE_FAILURE:
      return {
        ...initialState,
        PickDoneData: null,
        PickDoneErr: action.payload,
      };

    case TOActions.FETCH_TASKID_DETAILS_SUCCESS:
      return {
        ...initialState,
        TaskIdDetailsData: action.payload,
        TaskIdDetailsErr: null,
      };

    case TOActions.FETCH_TASKID_DETAILS_FAILURE:
      return {
        ...initialState,
        TaskIdDetailsData: null,
        TaskIdDetailsErr: action.payload,
      };

    case TOActions.FETCH_BIN_DETAILS_SUCCESS:
      return {
        ...initialState,
        GetBinData: action.payload,
        GetBinErr: null,
      };

    case TOActions.FETCH_BIN_DETAILS_FAILURE:
      return {
        ...initialState,
        GetBinData: null,
        GetBinErr: action.payload,
      };

    case TOActions.BIN_PICKING_SUCCESS:
      return {
        ...initialState,
        BinPickData: action.payload,
        BinPickErr: null,
      };

    case TOActions.BIN_PICKING_FAILURE:
      return {
        ...initialState,
        BinPickData: null,
        BinPickErr: action.payload,
      };

    default:
      return state;
  }
};
